import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c980543e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "imagelabel-view" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_7 = { class: "size" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Guardar ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Finalizar ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Buscar")

import { ref, onMounted, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import { SamplingPoint } from "@/types/samplingpoint.type.ts";
import { User } from "@/types/user.type.ts";
import { CameraConfiguration } from "@/types/cameraconfiguration.type";
import { getSamplingPointsNoRelations } from "@/service/samplingpoint.service";
import { getCamerasConfigurationByStationId } from "@/service/cameraConfiguration.service";
import {
  postClassificationImage,
  getNewCodeClassification,
  getOneClassificationWithImages,
} from "@/service/classificationImage.service.ts";
import { RootState } from "@/types/state.type";
import { ImageLabelHistory } from "@/types/imageLabel.type";

import { useStore } from "vuex";
import { ArrowDown, ArrowUp, Grid, Picture } from "@element-plus/icons-vue";
import ImagesLabelGallery from "@/components/processTracking/imageLabel/imageLabelGallery.component";
import ImagesLabelGalleryMultiple from "@/components/processTracking/imageLabel/imageLabelGalleryMultiple.component";
import ImageLabelFilter from "@/components/processTracking/imageLabel/imageLabelFilter.component";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { FilterImagesLabel } from "@/types/imageLabel.type.ts";
import { ClassificationImage } from "@/types/classificationImage.type";

import { ImageLabelData } from "@/types/Image.type.ts";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore<RootState>();
const { t } = useI18n();
const typeShow = route.query.type;

// Componentes
const formCmp = ref<InstanceType<typeof ImagesLabelGallery> | null>(null);
const multipleCmp = ref<InstanceType<typeof ImagesLabelGalleryMultiple> | null>(null);
const filterCmp = ref<InstanceType<typeof ImageLabelFilter> | null>(null);
const galleryKey = ref<number>(0);
const gridKey = ref<number>(0);

const isCreate = ref(false);
const showImagesLabelGallery = ref<boolean>(false);
const notSave = ref<boolean>(false);
const notShow = ref<boolean>(true);

const optionsImages = ref<FilterImagesLabel>({
  label: undefined,
  lighting_condition: undefined,
  estimations: undefined,
  training_data: undefined,
});

/**
 * FILTROS
 */
const dialogVisible = ref<boolean>(false);

const formFilter = ref<{
  samplingPoint?: SamplingPoint;
  fromDateTime?: Date;
  toDateTime?: Date;
  numberImageLabel?: number;
  cameras?: string[];
  showCameras?: string[];

  type: string;
}>({
  samplingPoint: undefined,
  fromDateTime: undefined,
  toDateTime: undefined,
  numberImageLabel: 4,
  type: "picture",
  cameras: [] as string[],
  showCameras: [] as string[],
});

const newClassification = ref<ClassificationImage>({
  id: undefined,
  name: undefined,
  code: undefined,
  dateTime: undefined,
  fromDateTime: undefined,
  toDateTime: undefined,
  samplingPoint: undefined,
  user: store?.state?.auth?.user,
});

/**
 * Mantener los cambios actualizados
 */
const arrayImages = ref<ImageLabelData[]>([]);
const arraySrc = ref<Record<string, string>>({});
const arrayCopyImages = ref<ImageLabelData[]>([]);
const arrayLabels = ref<ImageLabelData[]>([]);

onBeforeMount(async () => {
  const samplingPointId = route.query.samplingPoint;
  const sampResponse = await getSamplingPointsNoRelations(
    undefined,
    undefined,
    undefined,
    undefined,
    ["station"]
  );
  samplingPoints.value = sampResponse.data;
  formFilter.value.samplingPoint = samplingPoints.value.find((_) => _.id == samplingPointId);
  await getCameraConfiguration();
});
onMounted(async () => {
  if (route.query.type === "create") {
    isCreate.value = true;
    // newClassification.value.code = await getNewCodeClassification();
    newClassification.value.code = "PENDING";
  } else {
    const classification = await getOneClassificationWithImages(route.query.classification);
    newClassification.value.id = classification.id;
    newClassification.value.code = classification.code;
    newClassification.value.name = classification.name;
    newClassification.value.user = classification.user;
    formFilter.value.fromDateTime = classification.fromDateTime;
    formFilter.value.toDateTime = classification.toDateTime;
  }
});

const samplingPoints = ref<SamplingPoint[]>([]);
const camerasConfiguration = ref<CameraConfiguration[]>([]);

const disabledData = (date: Date) => {
  return date.getTime() > Date.now(); // Deshabilitar fechas futuras
};

/**
 * Obtener camara de configuraciones
 */
const getCameraConfiguration = async () => {
  const samplingPointSelected = formFilter.value.samplingPoint;
  if (samplingPointSelected?.station?.id) {
    camerasConfiguration.value = await getCamerasConfigurationByStationId(
      samplingPointSelected.station.id
    );
  }

  formFilter.value.showCameras = [];
  camerasConfiguration.value.forEach((element) => {
    if (element.imageProcessingTime != null) {
      const name = element.camera.name;
      let type = "";
      switch (element.imageProcessingTime) {
        case "DAY":
          formFilter.value.cameras[0] = element.camera.code;
          type = ` (${element.imageProcessingTime} >= ${formFilter.value.samplingPoint.station.night})`;
          break;
        case "NIGHT":
          formFilter.value.cameras[1] = element.camera.code;
          type = ` (${element.imageProcessingTime} < ${formFilter.value.samplingPoint.station.night})`;
          break;
        case "ALL_DAY":
          formFilter.value.cameras[0] = element.camera.code;
          break;
        default:
          break;
      }

      formFilter.value.showCameras.push(`${name}${type}`);
    }
  });

  if (formFilter.value.showCameras.length < 2) {
    formFilter.value.showCameras.push(`-`);
  }
};

/**
 * Botón: Visualizar
 */
const showImagesForLabeling = () => {
  showImagesLabelGallery.value = true;
  notSave.value = false;
  notShow.value = true;
};

/**
 * Botón: Guardar clasificación
 */
const saveClassification = async () => {
  newClassification.value.fromDateTime = formFilter.value.fromDateTime;
  newClassification.value.toDateTime = formFilter.value.toDateTime;
  newClassification.value.samplingPoint = formFilter.value.samplingPoint;
  newClassification.value.imageLabel =
    formFilter.value.type == "picture" ? formCmp.value.labelArray : multipleCmp.value.labelArray;
  if (newClassification.value.id) {
    newClassification.value.imageLabel = newClassification.value.imageLabel.map((c) => ({
      ...c,
      classification: { id: newClassification.value.id },
    }));
  }

  newClassification.value.imageLabelHistory =
    formFilter.value.type == "picture"
      ? (formCmp.value.labelArray as ImageLabelHistory[])
      : (multipleCmp.value.labelArray as ImageLabelHistory[]);
  newClassification.value.dateTime = new Date();

  newClassification.value.code =
    newClassification.value.code === "PENDING"
      ? await getNewCodeClassification()
      : newClassification.value.code;
  newClassification.value.name = newClassification.value.code;

  const classificationImage = await postClassificationImage(newClassification.value);

  if (classificationImage) {
    notSave.value = true;
    notShow.value = false;

    ElMessage.success(t("success.action"));
    newClassification.value.code = "PENDING";
  }
};

/**
 * Botón: Guardar mini clasificación
 */
const saveMiniClassification = async () => {
  newClassification.value.fromDateTime = formFilter.value.fromDateTime;
  newClassification.value.toDateTime = formFilter.value.toDateTime;
  newClassification.value.samplingPoint = formFilter.value.samplingPoint;
  newClassification.value.imageLabel =
    formFilter.value.type == "picture" ? formCmp.value.labelArray : multipleCmp.value.labelArray;
  if (newClassification.value.id) {
    newClassification.value.imageLabel = newClassification.value.imageLabel.map((c) => ({
      ...c,
      classification: { id: newClassification.value.id },
    }));
    newClassification.value.imageLabelHistory = [] as ImageLabelData[];
  }
  newClassification.value.code =
    newClassification.value.code === "PENDING"
      ? await getNewCodeClassification()
      : newClassification.value.code;

  newClassification.value.name = newClassification.value.code;

  newClassification.value.dateTime = null;
  const classificationImage = await postClassificationImage(newClassification.value);

  if (classificationImage && classificationImage.id) {
    //- Inicializar de nuevo la lista de etiquetados nuevos
    arrayLabels.value = [] as ImageLabelData[];
    newClassification.value.id = classificationImage.id;
    ElMessage.success(t("success.action"));
  }
};

/**
 *
 * @param type
 */
const changeBtnView = (type: string) => {
  formFilter.value.type = type;
  var blueBtn = document.getElementsByClassName("selected");
  if (blueBtn[0]) {
    blueBtn[0].className = blueBtn[0].className.replace("selected", "");
  }
  const btnDate = document.getElementById(type);
  btnDate?.classList.add("selected");
};

/**
 * Actualizar valores cuando hay nuevos valos de label y lighting_condition
 * @param images
 * @param src
 * @param copy
 * @param labels
 */
const getImages = (
  images: ImageLabelData[],
  src: Record<string, string>,
  copy: ImageLabelData[],
  labels: ImageLabelData[]
) => {
  arrayImages.value = images;
  arraySrc.value = src;
  arrayCopyImages.value = copy;
  arrayLabels.value = labels;
};

//- Diálogo Filtros

/**
 * Abrir dialogo
 */
const openDialog = () => {
  dialogVisible.value = true;
};

/**
 * Aplicar cambios de los filtros
 * @param applyFilter
 */
const applyChanges = async (applyFilter: boolean) => {
  const newLabels =
    formFilter.value.type == "picture" ? formCmp.value.labelArray : multipleCmp.value.labelArray;
  if (newLabels && newLabels.length > 0) {
    await saveMiniClassification();
  }

  //- Quitar filtros
  optionsImages.value = filterCmp.value.updateOptionsImage(applyFilter);
  //- Cerrar ventana
  dialogVisible.value = false;
  arrayImages.value = [] as ImageData[];

  //- Actualizar componentes
  if (formFilter.value.type == "picture") {
    galleryKey.value++;
  } else {
    gridKey.value++;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      style: {"width":"100% height: 100vh"},
      gutter: 5
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { lg: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "card-section first-card" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t("title.labelingTools")), 1),
                _createVNode(_component_el_form, {
                  model: formFilter.value,
                  ref: "form"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.monitorizationPoint")), 1),
                    _createVNode(_component_el_form_item, {
                      prop: "samplingPoint",
                      class: "full-width-item size"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formFilter.value.samplingPoint,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFilter.value.samplingPoint) = $event)),
                          "value-key": "id",
                          style: {"width":"100%"},
                          onChange: getCameraConfiguration,
                          disabled: "",
                          class: "sizeText"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoints.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.name,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodStartDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item size" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          "disabled-date": disabledData,
                          style: {"width":"100%"},
                          modelValue: formFilter.value.fromDateTime,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFilter.value.fromDateTime) = $event)),
                          type: "datetime",
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          disabled: _unref(typeShow) == 'view' || showImagesLabelGallery.value || !notShow.value,
                          class: "sizeText"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.periodEndDate")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item size" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          "disabled-date": disabledData,
                          style: {"width":"100%"},
                          modelValue: formFilter.value.toDateTime,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFilter.value.toDateTime) = $event)),
                          type: "datetime",
                          format: "YYYY-MM-DD HH:mm",
                          placeholder: "DD/MM/AAAA hh:mm",
                          disabled: _unref(typeShow) == 'view' || showImagesLabelGallery.value || !notShow.value
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.numberImageLabel")), 1),
                    _createVNode(_component_el_form_item, { class: "full-width-item size" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formFilter.value.numberImageLabel,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFilter.value.numberImageLabel) = $event)),
                          max: "6",
                          min: "1",
                          style: {"width":"100%"},
                          disabled: showImagesLabelGallery.value || !notShow.value
                        }, {
                          "decrease-icon": _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ArrowDown))
                              ]),
                              _: 1
                            })
                          ]),
                          "increase-icon": _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ArrowUp))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("label.camera")) + "s", 1),
                    (camerasConfiguration.value && formFilter.value.samplingPoint && formFilter.value.showCameras)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formFilter.value.showCameras, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, { key: index }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : (!camerasConfiguration.value && formFilter.value.samplingPoint)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " No hay cámaras configuradas, pide al administrador que las configure. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_tag, {
                                  type: "info",
                                  class: "size"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_6
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_row, { class: "btn-view" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.$t('tooltip.picture'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          id: "picture",
                          class: "btn-view selected",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeBtnView('picture')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Picture))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"]),
                    _createVNode(_component_el_tooltip, {
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.$t('tooltip.grid'),
                      placement: "bottom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          id: "grid",
                          class: "btn-view",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (changeBtnView('grid')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Grid))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "size",
                  type: "primary",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showImagesForLabeling())),
                  disabled: 
              (!formFilter.value.samplingPoint || !formFilter.value.fromDateTime || !formFilter.value.toDateTime) &&
              (_unref(typeShow) == 'view' || notShow.value)
            
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.visualize")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, { class: "card-section second-card" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("label.classification")), 1),
                _createVNode(_component_el_row, { class: "row-classification" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, {
                      type: "info",
                      class: "size"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(newClassification.value.code), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { class: "row-classification" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, {
                      type: "info",
                      class: "size"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(newClassification.value?.user?.email), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { class: "row-classification" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: newClassification.value.name,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newClassification.value.name) = $event)),
                      class: "size",
                      placeholder: "Please input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { class: "group-btn" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { class: "btn-classification" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (saveMiniClassification())),
                          disabled: _unref(typeShow) != 'create' || !showImagesLabelGallery.value || notSave.value || !isCreate.value
                        }, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { class: "btn-classification" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (saveClassification())),
                          disabled: _unref(typeShow) == 'view' || !showImagesLabelGallery.value || notSave.value
                        }, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { lg: 20 }, {
          default: _withCtx(() => [
            (showImagesLabelGallery.value)
              ? (_openBlock(), _createBlock(_component_el_card, {
                  key: 0,
                  class: "main-content imagenes-wrapper"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "local-floating-button",
                      type: "primary",
                      circle: "",
                      onClick: openDialog
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Operation)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (formFilter.value.type == 'picture')
                      ? (_openBlock(), _createBlock(_unref(ImagesLabelGallery), {
                          ref_key: "formCmp",
                          ref: formCmp,
                          filters: formFilter.value,
                          images: arrayImages.value,
                          imagesrc: arraySrc.value,
                          copy: arrayCopyImages.value,
                          labels: arrayLabels.value,
                          filterImages: optionsImages.value,
                          onUpdateImages: getImages,
                          notEdit: false,
                          key: 'picture-' + galleryKey.value
                        }, null, 8, ["filters", "images", "imagesrc", "copy", "labels", "filterImages"]))
                      : _createCommentVNode("", true),
                    (formFilter.value.type == 'grid')
                      ? (_openBlock(), _createBlock(_unref(ImagesLabelGalleryMultiple), {
                          ref_key: "multipleCmp",
                          ref: multipleCmp,
                          filters: formFilter.value,
                          images: arrayImages.value,
                          imagesrc: arraySrc.value,
                          copy: arrayCopyImages.value,
                          labels: arrayLabels.value,
                          filterImages: optionsImages.value,
                          onUpdateImages: getImages,
                          key: 'grid-' + gridKey.value
                        }, null, 8, ["filters", "images", "imagesrc", "copy", "labels", "filterImages"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "Filtros",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dialogVisible).value = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (applyChanges(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (applyChanges(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ImageLabelFilter), {
          ref_key: "filterCmp",
          ref: filterCmp
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})